export default "__VITE_ASSET__dac48740__"